module.exports = __webpack_public_path__ + "static/media/bg_bottom.98dfee49.png";